import { __awaiter, __generator } from "tslib";
import { Fetch } from '@ekuaibao/fetch';
var defaultPreviewURL = 'https://doc.ekuaibao.com';
export default initPlatformInfo;
export function initPlatformInfo() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var platformInfo, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4, Fetch.GET('/api/platformInfo', undefined, undefined, { hiddenLoading: true })];
                case 1:
                    platformInfo = _b.sent();
                    window.PLATFORMINFO = platformInfo;
                    window.isZhongDian = (_a = platformInfo === null || platformInfo === void 0 ? void 0 : platformInfo.name) === null || _a === void 0 ? void 0 : _a.includes('zhongdian');
                    window.PREVIEW_DOMAIN = (platformInfo === null || platformInfo === void 0 ? void 0 : platformInfo.previewUrl) || defaultPreviewURL;
                    return [3, 3];
                case 2:
                    e_1 = _b.sent();
                    console.log(e_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    });
}
